import { ReactNode, Suspense } from "react";
import { Icons } from "assets";
import classNames from "classnames";
import styles from "./style.module.scss";

interface LayoutProps {
  children: ReactNode;
  image?: string | undefined;
}

const AuthLayout = ({ children, image }: LayoutProps) => {
  return (
    <div className={classNames(styles.auth_layout_wrapper)}>
      <Icons.Logo className={styles.logo} />

      <div className={styles.mobileLayout}>
        <div className={styles.mobileImageContainer}>
          <div
            className={styles.mobileImage}
            style={image ? { backgroundImage: `url(${image})` } : {}}
          />

          <div className={styles.mobileFormContainer}>
            <Suspense>{children}</Suspense>
          </div>
        </div>
      </div>

      <div className={classNames(styles.desktopLayout)}>
        <main
          className={classNames(
            styles.auth_layout_main,
            "flex gap-8  items-center w-full",
          )}
        >
          <div className=" md:w-auto flex flex-col md:flex-1 w-1/2 h-full">
            <Icons.Logo className={classNames(styles.logo, "sm:flex hidden")} />

            <Suspense>
              <div
                className={classNames(
                  styles.mainContainer,
                  "flex h-full w-full pt-8",
                )}
              >
                {children}
              </div>
            </Suspense>
          </div>
          <div
            className={classNames(
              styles.auth_layout_content,
              "items-center justify-end w-1/2",
            )}
          >
            {image && (
              <img
                src={image}
                alt="auth-illustration"
                className={styles.auth_image}
              />
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AuthLayout;
